var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Layout", [
    _c("div", { staticClass: "ep__main_content pt-80" }, [
      _c("section", { staticClass: "content b-radius-5 pt-40 pb-40" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            {
              staticClass: "spage p-0 d-flex flex-wrap justify-content-between"
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "div",
                  { staticClass: "contact-us-content" },
                  [
                    _c(
                      "EpLabel",
                      {
                        staticClass: "header-title",
                        attrs: { "data-testid": "headtitle" }
                      },
                      [_vm._v("CONTACT US")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "introduction-text",
                        attrs: { "data-testid": "introduction" }
                      },
                      [
                        _vm._v(
                          "We would love to help you if you have any questions or require further information."
                        ),
                        _c("br"),
                        _vm._v("Here is how you can reach us.")
                      ]
                    ),
                    _c("div", { staticClass: "row m-0" }, [
                      _c("div", { staticClass: "column-icons" }, [
                        _c("img", {
                          attrs: {
                            src: require("@static/img/address.svg"),
                            alt: "Address"
                          }
                        })
                      ]),
                      _c(
                        "div",
                        { staticClass: "pl-24 col" },
                        [
                          _c("EpLabel", {
                            staticClass: "mb-0 contact-description",
                            attrs: { "data-testid": "Address" },
                            domProps: { innerHTML: _vm._s(_vm.getAddress) }
                          })
                        ],
                        1
                      ),
                      _c("div", {
                        staticClass: "w-100 row-contact-us-content"
                      }),
                      _c("div", { staticClass: "column-icons" }, [
                        _c("img", {
                          attrs: {
                            src: require("@static/img/contactNumber.svg"),
                            alt: "Tel"
                          }
                        })
                      ]),
                      _c(
                        "div",
                        { staticClass: "pl-24 col" },
                        [
                          _c(
                            "EpLabel",
                            {
                              staticClass: "mb-0 contact-description",
                              attrs: { "data-testid": "Tel" }
                            },
                            [_vm._v(_vm._s(_vm.getContactNumber))]
                          )
                        ],
                        1
                      ),
                      _c("div", {
                        staticClass: "w-100 row-contact-us-content"
                      }),
                      _c("div", { staticClass: "column-icons" }, [
                        _c("img", {
                          attrs: {
                            src: require("@static/img/contactEmail.svg"),
                            alt: "Email"
                          }
                        })
                      ]),
                      _c(
                        "div",
                        { staticClass: "pl-24 col" },
                        [
                          _c(
                            "EpLabel",
                            {
                              staticClass: "mb-0 contact-description",
                              attrs: { "data-testid": "Email" }
                            },
                            [_vm._v(_vm._s(_vm.getContactEmail))]
                          )
                        ],
                        1
                      ),
                      _c("div", {
                        staticClass: "w-100 row-contact-us-content"
                      }),
                      _c("div", { staticClass: "column-icons" }, [
                        _c("img", {
                          attrs: {
                            src: require("@static/img/workingTime.svg"),
                            alt: "Working hours"
                          }
                        })
                      ]),
                      _c(
                        "div",
                        { staticClass: "pl-24 col" },
                        [
                          _c("EpLabel", {
                            staticClass: "mb-0 contact-description",
                            attrs: { "data-testid": "WorkingHours" },
                            domProps: { innerHTML: _vm._s(_vm.getWorkingTime) }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "crop-area crop-area-option" }, [
                _c("img", {
                  staticClass: "card-img-top scale-map",
                  attrs: {
                    id: "map-image",
                    src: _vm.getMapImage,
                    alt: _vm.getAddress,
                    "data-testid": "MapImage"
                  }
                })
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }